import { useEffect, useState } from 'react'
import { Button, Grid } from '@mui/material'

const Buttons = ({ text= '', sx = {}, onClick = () => {}, type}) => {

  return (
    <Button type={type} sx={sx} onClick={onClick}>
        {text}
    </Button>
  )
}

export default Buttons
